








































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import RadioInlineGroup from '@/components/RadioInlineGroup.vue'
import RadioButton from '@/components/RadioButton.vue'
import Icon from '@/components/Icon.vue'
import { EPaymentMethodType, EResidentPaymentMethodAccountType, EUserType, IFacility, IResidentContact, IResident, US_STATES_LIST } from '@zunta/configurations'
import { ZIP_MASK } from '@/constants'
import { ISelectItem } from '@/interfaces'
import { User } from '@/classes/User'
import Api from '@/api'
import { PaymentsModule } from '@/store/modules/payments.module'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { minLength, requiredIf } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { cardNumberOptions } from '@/utils/payment'
const luhn = require('luhn')

const isExpirationValid = (value: any) => {
  // get current year and month
  const d = new Date()
  const currentYear = d.getFullYear()
  const currentMonth = d.getMonth() + 1
  // get parts of the expiration date
  const parts = value.split('/')
  const year = parseInt(parts[1], 10) + 2000
  const month = parseInt(parts[0], 10)
  // compare the dates
  return !(year < currentYear || (year === currentYear && month < currentMonth))
}

@Component({
  props: {
    residentId: {
      type: [String, Number],
      required: true
    },
    paymentMethod: {
      required: false
    },
    ccDisabled: {
      type: Boolean,
      default: false
    },
    sendPaymentMethodOnEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LoaderWrapper,
    InputValidator,
    SelectV2,
    InputV2,
    Icon,
    RadioButton,
    RadioInlineGroup,
    ModalV2
    // ErrorMessages
  }
})
export default class PaymentMethodModal extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  user: User = Api.getUser() as User
  ZIP_MAKS = ZIP_MASK
  cardNumberOptions = cardNumberOptions
  ccDisabled = this.$props.ccDisabled
  type = this.ccDisabled ? EPaymentMethodType.ECHECK : EPaymentMethodType.CREDIT_CARD
  EPaymentMethodType: any = EPaymentMethodType
  selectedContact: IResidentContact | null = null
  paymentMethodData: any = {
    echeckAccountType: EResidentPaymentMethodAccountType.CHECKING,
    echeckRoutingNumber: '',
    securityCode: ''
  }
  errors: string[] = []
  tempContactData: any = {}
  tempContactErrors: string[] = []
  creatingPaymentMethod: boolean = false
  isEdit: boolean = false

  isTransiting: boolean = false
  isLoading: boolean = false
  isRoutingValid: boolean = true

  validations (): any {
    return {
      paymentMethodData: {
        // credit card
        cardHolderName: {
          required: requiredIf(() => this.isCC)
        },
        cardNumber: {
          required: requiredIf(() => this.isCC && !this.isEdit),
          validCC: (value: any) => !this.isCC || !value || ((cardNumberOptions(this.isAmericanExpressCard, 'length', true) as RegExp).test((value || '').replace(/\s/g, '')) && luhn.validate(value))
        },
        expiration: {
          required: requiredIf(() => this.isCC),
          valid: (value: any) => !this.isCC || !value || (isExpirationValid(value) && /^\d{2}\/(\d{2}|\d{4})$/.test(value))
        },
        securityCode: {
          // required: requiredIf(() => this.type === EPaymentMethodType.CREDIT_CARD),
          // minLength: minLength(3),
          valid: (value: any) => !this.isCC || !value || ((cardNumberOptions(this.isAmericanExpressCard, 'CVC', true) as RegExp).test(value))
          // valid: (value: any) => !value || (this.isAmericanExpressCard && /^\d{4}$/.test(value)) || /^\d{3}$/.test(value)
        },
        // echeck
        echeckAccountName: {
          required: requiredIf(() => this.isECheck)
        },
        echeckAccountType: {
          required: requiredIf(() => this.isECheck)
        },
        echeckRoutingNumber: {
          required: requiredIf(() => this.isECheck),
          minLength: minLength(9),
          /** async validation does not want to work properly */
          valid: () => this.isRoutingValid
        },
        echeckAccountNumber: {
          required: requiredIf(() => !this.isEdit && this.isECheck)
        }
      },
      tempContactData: {
        state: {
          required: requiredIf(() => !this.selectedContact && this.isCC)
        },
        city: {
          required: requiredIf(() => !this.selectedContact && this.isCC)
        },
        zipCode: {
          minLength: minLength(5),
          required: requiredIf(() => !this.selectedContact && this.isCC)
        },
        addressLine1: {
          required: requiredIf(() => !this.selectedContact && this.isCC)
        }
      }
    }
  }

  get contacts () {
    return this.$store.state.resident.residentContacts ? this.$store.state.resident.residentContacts : []
  }

  get filteredContacts () {
    return this.contacts.filter((c: IResidentContact) => c.addressLine1 || c.addressLine2 || c.addressLine3 || c.city || c.state || c.zipCode)
  }

  get stateList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      value: stateShortName,
      key: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  isContactWithStreetAddress (contact: IResidentContact) {
    return contact.addressLine1 || contact.addressLine2 || contact.addressLine3
  }

  getContactCityStateZip (contact: IResidentContact) {
    return [contact.city, contact.state, contact.zipCode].filter(Boolean).join(', ')
  }

  get echeckAccountTypeItemsList () {
    return Object.values(EResidentPaymentMethodAccountType)
      .map((accountType: string) => ({
        value: accountType,
        key: accountType,
        content: accountType
      }))
  }

  get transitionClasses () {
    if (this.type === EPaymentMethodType.ECHECK) {
      return {
        in: 'fadeInRight',
        out: 'fadeOutLeft'
      }
    }
    return {
      in: 'fadeInLeft',
      out: 'fadeOutRight'
    }
  }

  get isCC () {
    return this.type === EPaymentMethodType.CREDIT_CARD
  }

  get isECheck () {
    return this.type === EPaymentMethodType.ECHECK
  }

  get ccNumber () {
    return this.isEdit ? this.$props.paymentMethod.first6Digits : this.paymentMethodData.cardNumber
  }

  get isVisaCard () {
    if (!this.ccNumber) {
      return false
    }
    return /^4/.test(this.ccNumber.replace(/\s/g, ''))
  }

  get isMasterCard () {
    if (!this.ccNumber) {
      return false
    }
    return /^5/.test(this.ccNumber.replace(/\s/g, ''))
  }

  get isAmericanExpressCard () {
    if (!this.ccNumber) {
      return false
    }
    return /^3/.test(this.ccNumber.replace(/\s/g, ''))
  }

  get isDiscoverCard () {
    if (!this.ccNumber) {
      return false
    }
    return /^6/.test(this.ccNumber.replace(/\s/g, ''))
  }

  brandName (isIconName?: boolean) {
    if (this.isMasterCard) {
      return isIconName ? 'mastercard' : 'MasterCard'
    }
    if (this.isVisaCard) {
      return isIconName ? 'visa' : 'Visa'
    }
    if (this.isAmericanExpressCard) {
      return isIconName ? 'amex' : 'AmericanExpress'
    }
    if (this.isDiscoverCard) {
      return isIconName ? 'discover' : 'Discover'
    }
    return isIconName ? '' : 'Other'
  }

  mounted () {
    this.residentModuleInstance.fetchResidentContacts(this.$props.residentId)
    if (this.$props.paymentMethod) {
      this.isEdit = true
      this.setEditPaymentMethod()
    }
  }

  preventNumber (e: any) {
    if (/\d/gm.test(e.key)) {
      e.preventDefault()
    }
  }

  setIsTransiting (value: boolean) {
    this.isTransiting = value
  }

  changeType (item: ISelectItem) {
    if (this.isEdit) {
      return
    }
    this.type = item.value
    this.$v.$reset()
    // this.errors = []
  }

  selectContact (contact: any) {
    this.selectedContact = contact
  }

  // validateTempContact () {
  //   this.tempContactErrors = []
  //   if (this.selectedContact || this.type !== EPaymentMethodType.CREDIT_CARD) {
  //     return true
  //   }
  //   if (!this.tempContactData.state) {
  //     this.tempContactErrors.push('State Required')
  //   }
  //   if (!this.tempContactData.city) {
  //     this.tempContactErrors.push('City Required')
  //   }
  //   if (!this.tempContactData.zipCode) {
  //     this.tempContactErrors.push('Zip Code Required')
  //   }
  //   if (!this.tempContactData.addressLine1) {
  //     this.tempContactErrors.push('Address Required')
  //   }
  //   return this.tempContactErrors.length === 0
  // }

  // async validate () {
  //   this.errors = []
  //   const needValidateCCData = !this.isEdit
  //   if (this.type === EPaymentMethodType.CREDIT_CARD) {
  //     if (!luhn.validate(this.paymentMethodData.cardNumber)) {
  //       this.errors.push('Incorrect credit card number')
  //     }
  //     if (!this.paymentMethodData.cardHolderName) {
  //       this.errors.push('Card Holder Name Required')
  //     }
  //     if (needValidateCCData && !/^(\d{16}|\d{15})$/.test((this.paymentMethodData.cardNumber || '').replace(/\s/g, ''))) {
  //       this.errors.push('Card Number must be 15-16 digits')
  //     }
  //     if (this.paymentMethodData.securityCode && this.isAmericanExpressCard && !/^\d{4}$/.test(this.paymentMethodData.securityCode)) {
  //       this.errors.push('Security Code must be 4 digits')
  //     }
  //     if (this.paymentMethodData.securityCode && !this.isAmericanExpressCard && !/^\d{3}$/.test(this.paymentMethodData.securityCode)) {
  //       this.errors.push('Security Code must be 3 digits')
  //     }
  //     if (!/^\d{2}\/(\d{2}|\d{4})$/.test(this.paymentMethodData.expiration)) {
  //       this.errors.push('Expiration Date Is Required')
  //     }
  //     if (this.paymentMethodData.expiration) {
  //       // get current year and month
  //       const d = new Date()
  //       const currentYear = d.getFullYear()
  //       const currentMonth = d.getMonth() + 1
  //       // get parts of the expiration date
  //       const parts = this.paymentMethodData.expiration.split('/')
  //       const year = parseInt(parts[1], 10) + 2000
  //       const month = parseInt(parts[0], 10)
  //       // compare the dates
  //       if (year < currentYear || (year === currentYear && month < currentMonth)) {
  //         this.errors.push('Invalid expiration date')
  //       }
  //     }
  //   } else if (this.type === EPaymentMethodType.ECHECK) {
  //     if (!/^\d{9}$/.test(this.paymentMethodData.echeckRoutingNumber)) {
  //       this.errors.push('Routing Number must be 9 digits')
  //     } else {
  //       const banks = await this.paymentsModuleInstance.getBanks({ routing: this.paymentMethodData.echeckRoutingNumber })
  //       if (!banks || !banks.length) {
  //         this.errors.push('Routing number is invalid')
  //       }
  //     }
  //     if (!this.paymentMethodData.echeckAccountName) {
  //       this.errors.push('Name on Account Is Required')
  //     }
  //     if (needValidateCCData && !this.paymentMethodData.echeckAccountNumber) {
  //       this.errors.push('Account Number Is Required')
  //     }
  //   }
  //   if (!this.validateTempContact() && this.type === EPaymentMethodType.CREDIT_CARD) {
  //     this.errors.push('Billing Address Is Required')
  //   }
  //   return this.errors.length === 0
  // }

  async save () {
    this.$v.$touch()
    if (this.isECheck) {
      if (!this.paymentMethodData.echeckRoutingNumber) {
        return
      }
      this.isLoading = true
      const banks = await this.paymentsModuleInstance.getBanks({ routing: this.paymentMethodData.echeckRoutingNumber })
      this.isRoutingValid = banks && banks.length
      this.isLoading = false
      if (!this.isRoutingValid) {
        return
      }
    }
    if (this.$v.$anyError) {
      this.isLoading = false
      return
    }
    let currentPaymentMethodData: any = {}

    if (this.isCC) {
      currentPaymentMethodData = {
        brandName: this.brandName(),
        cardHolderName: this.paymentMethodData.cardHolderName,
        expiration: this.paymentMethodData.expiration,
        securityCode: this.paymentMethodData.securityCode
      }
      if (!this.isEdit) {
        currentPaymentMethodData.cardNumber = this.paymentMethodData.cardNumber.replace(/\s/g, '')
      }
    } else if (this.isECheck) {
      currentPaymentMethodData = {
        echeckAccountNumber: this.paymentMethodData.echeckAccountNumber,
        echeckAccountType: this.paymentMethodData.echeckAccountType,
        echeckAccountName: this.paymentMethodData.echeckAccountName,
        echeckRoutingNumber: this.paymentMethodData.echeckRoutingNumber
      }
    }

    const contact: any = this.selectedContact || this.tempContactData

    this.isLoading = true

    const input: any = {
      residentId: this.$props.residentId,
      data: {
        type: this.type,
        state: contact.state || '',
        city: contact.city || '',
        zip: contact.zipCode || '',
        address: `${contact.addressLine1 || ''} ${contact.addressLine2 || ''} ${contact.addressLine3 || ''}`,
        ...currentPaymentMethodData
      }
    }

    if (this.isEdit) {
      input.paymentMethodId = this.$props.paymentMethod.id
    }

    const response: any = this.isEdit
      ? await this.residentModuleInstance.editPaymentMethod(input)
      : await this.residentModuleInstance.addPaymentMethod(input)

    this.isLoading = false

    if (response.status !== 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: (response.message || ['Something went wrong']).join('\n'),
        header: this.isEdit ? `Edit Payment Method` : `Create Payment Method`,
        icon: 'warning'
      })
      return
    }
    this.$emit('close', response && response.id ? response.id : null)

    if (this.isEdit && this.$props.sendPaymentMethodOnEdit) {
      if (input.data.type === EPaymentMethodType.ECHECK) {
        input.data.echeckRouting = input.data.echeckRoutingNumber
      }
      this.$emit('updated', input.data)
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: this.isEdit ? `Payment Method edited` : 'Payment Method added',
      header: this.isEdit ? `Edit Payment Method` : `Create Payment Method`,
      icon: 'check'
    })
  }

  setEditPaymentMethod () {
    const pm = this.$props.paymentMethod
    this.type = pm.type
    this.paymentMethodData = {
      ...pm,
      echeckRoutingNumber: pm.echeckRouting
    }

    if (!pm) {
      return
    }

    const matchedContact = this.contacts.find((contact: IResidentContact) => {
      return pm.state === contact.state &&
        pm.city === contact.city &&
        pm.zip === contact.zipCode &&
        pm.address === `${contact.addressLine1} ${contact.addressLine2 || ''} ${contact.addressLine3 || ''}`
    })

    if (matchedContact) {
      this.selectContact(matchedContact)
      return
    }

    this.tempContactData = {
      addressLine1: pm.address,
      state: pm.state,
      zipCode: pm.zip,
      city: pm.city
    }
  }
}
